import type { Router } from 'vue-router'
import verifyLoginGuard from '@/router/guard/verify-login'
import setPageTitleGuard from '@/router/guard/page-title'
import verifyPermissionGuard from '@/router/guard/verify-permission'

export default function registerRouterGuard(router: Router) {
  setPageTitleGuard(router)
  // 顺序上先确认登录态并拉取用户信息，再执行路由权限控制；
  // 这样 verifyPermissionGuard 读取到的是当前导航时的最新用户上下文。
  verifyLoginGuard(router)
  verifyPermissionGuard(router)
}
